/** @format */

import {Box} from '@mui/material';
import {Trans, useTranslation} from 'react-i18next';

import {KpiContainer} from '../Form/styles';
import {KPI_OPTIONS, TOOLTIP_TEXTS} from '../Form/constants';
import {getKpiSymbol} from '../Form/helpers';
import FieldLabelWithHelp from '../Form/components/FieldLabelWithHelp';
import SelectField from '../Form/components/SelectField';
import DigitField from '../Form/components/DigitField';
import {KpiType, SelectFieldProps, DigitFieldProps} from '../../types';

interface KpiFieldProps {
  kpi: KpiType;
  kpiAmount: string;
  onKpiChange: SelectFieldProps['onChange'];
  onKpiAmountChange: DigitFieldProps['onChange'];
  disabled?: boolean;
}

const KpiField = ({
  kpi,
  kpiAmount,
  onKpiChange,
  onKpiAmountChange,
  disabled = false,
}: KpiFieldProps) => {
  const {t} = useTranslation();

  return (
    <Box>
      <FieldLabelWithHelp tooltipText={TOOLTIP_TEXTS.KPI}>
        <Trans>KPI</Trans>
      </FieldLabelWithHelp>
      <KpiContainer>
        <SelectField value={kpi} onChange={onKpiChange} options={KPI_OPTIONS} disabled={disabled} />
        <DigitField
          value={kpiAmount}
          onChange={onKpiAmountChange}
          placeholder={t('Значение')}
          symbol={getKpiSymbol(kpi)}
          disabled={disabled}
        />
      </KpiContainer>
    </Box>
  );
};

export default KpiField;
